export default function ConditionalRender({ predicate, children }) {
  if (predicate) {
    return children;
  } else {
    return null;
  }
}
